const noMoreFear = () => {
    const block = document.querySelector('.noMoreFear');

    if (!block) return;

    const buttons = block.querySelectorAll('.noMoreFear__title'),
        cards = block.querySelectorAll('.noMoreFear__item'),
        texts = block.querySelectorAll('.noMoreFear__text-block');
        
    let activeCard = 0;
    texts[activeCard].parentNode.style.height = texts[activeCard].offsetHeight + 10 + 'px';
    
    buttons.forEach((button, i) => {
        button.addEventListener('click', () => {         
            cards[activeCard].classList.remove('active');
            texts[activeCard].parentNode.style.height = 0;
            
            texts[i].parentNode.style.height = texts[i].offsetHeight + 10 + 'px';
            
            activeCard = i;

            if (!button.closest(".noMoreFear__item").classList.contains("active")) {
                button.closest(".noMoreFear__item").classList.add("active");
            }
        })        
    })
}

export default noMoreFear;